{
  "name": "m4-grid",
  "seed": 1,
  "track": "stadium",
  "fixedDtMs": 16.666666666666668,
  "cars": [
    { "id": "ai1", "ai": "fast", "spawn": { "x": 600, "y": 172, "angle": 0 } },
    { "id": "ai2", "ai": "normal", "spawn": { "x": 600, "y": 208, "angle": 0 } },
    { "id": "ai3", "ai": "normal", "spawn": { "x": 548, "y": 172, "angle": 0 } },
    { "id": "ai4", "ai": "slow", "spawn": { "x": 548, "y": 208, "angle": 0 } },
    { "id": "ai5", "ai": "fast", "spawn": { "x": 496, "y": 190, "angle": 0 } }
  ],
  "inputs": [],
  "captures": []
}
